// extracted by mini-css-extract-plugin
export default {"data-hook-wrapper":"_1RJI7","dataHookWrapper":"_1RJI7","core-badge":"_2z3Qs","coreBadge":"_2z3Qs"};